// Modules
import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { useHistory, useLocation, useParams } from "react-router-dom";
import moment from "moment";
import { useSelector } from "react-redux";

// Styled Components
import * as FILTER from "./filters.styles";
import { BiuCheckbox } from "../../biu-web-components/src/components";
import { MarginRight, MarginBottom } from "../../styles/common/space.styles";

// Components
import DateBar from "../date-bar/date-bar.component";

// Constant
import { constant } from "../../constants/contant";

// Selectors
import { getFacets } from "../../selectors/facets.selector";
import { capitalizedLang } from "../../selectors/common.selector";

// Types
import { QueryFilters, Filters as Filter } from "../../types/query-filters";
import { Store } from "../../types/store";

const Filters = () => {
  const facets = useSelector((state: any) => state.facet.data);
  const lang = useSelector((state: any) => capitalizedLang()(state));
  const dir = useSelector((state: any) => state.common.dir);

  const [eventCost, setEventCost]: any = useState(false);
  const [eventMode, setEventMode]: any = useState(false);
  const [eventStatus, setEventStatus]: any = useState(false);

  const [searchTerm, setSearchTerm]: any = useState("");
  const [eventType, setEventType]: any = useState(
    constant[lang].VARIABLES.DEFAULT_EVENT_TYPE
  );
  const [eventOn, SetEventOn] = useState("");
  const [interestDomain, setInterestDomain]: any = useState(
    constant[lang].VARIABLES.DEFAULT_ORGANIZING_UNIT
  );
  const [dateFilterType, setDateFilterType]: any = useState({
    type: "",
    startDate: null,
    endDate: null,
  });

  const location = useLocation();
  const history = useHistory();
  const params = useParams();

  const eventTypes = useSelector((state: Store) =>
    getFacets("event_type")(state)
  );
  // const organizingUnits = useSelector((state: Store) =>
  // 	getFacets('organizing_unit')(state),
  // );
  const interestedDomains = useSelector((state: Store) =>
    getFacets("event_interest_domains")(state)
  );

  useEffect(() => {
    const query = new QueryFilters(location.search, facets);
    setEventCost(query.parsedQuery.eventCost === "free");

    SetEventOn(!location.pathname.includes('past') ? "future" : "past");

    setEventMode(Boolean(query.parsedQuery.online));
    setSearchTerm(query.parsedQuery.search ? query.parsedQuery.search : "");
    setEventType(
      query.parsedQuery.eventType
        ? { label: query.parsedQuery.eventType }
        : constant[lang].VARIABLES.DEFAULT_EVENT_TYPE
    );
    if (query.parsedQuery.endDate && query.parsedQuery.startDate) {
      setDateFilterType({
        type: "calendar",
        startDate: query.parsedQuery.startDate,
        endDate: query.parsedQuery.endDate,
      });
    }
    setInterestDomain(
      query.parsedQuery.interestedDomain
        ? { label: query.parsedQuery.interestedDomain }
        : constant[lang].VARIABLES.DEFAULT_INTERESTED_DOMAIN
    );
  }, [location, lang]);

  const onReset = () => {
    setEventCost(false);
    setEventMode(false);
    setSearchTerm("");
    setEventType(constant[lang].VARIABLES.DEFAULT_EVENT_TYPE);
    setInterestDomain(constant[lang].VARIABLES.DEFAULT_INTERESTED_DOMAIN);
    // setOrganizingUnit(constant[lang].VARIABLES.DEFAULT_ORGANIZING_UNIT);
    setDateFilterType({
      type: "",
      startDate: null,
      endDate: null,
    });
    history.push(
      `${location?.pathname}?${
        eventOn === "past" ? "endDate" : "startDate"
      }=${moment().unix()}`
    );
  };

  const onTypeSelect = (event: any) => {
    setEventType(event.detail);
    let query: QueryFilters = new QueryFilters(location.search, facets);
    let newQuery: Filter = { ...query.parsedQuery };
    event.detail.value
      ? (newQuery.eventType = event.detail.label)
      : delete newQuery.eventType;
    navigate(query, newQuery);
  };

  const onInterestDomainSelect = (event: any) => {
    setInterestDomain(event.detail);
    let query: QueryFilters = new QueryFilters(location.search, facets);
    let newQuery: Filter = { ...query.parsedQuery };
    event.detail.value
      ? (newQuery.interestedDomain = event.detail.label)
      : delete newQuery.interestedDomain;
    navigate(query, newQuery);
  };

  const onEventCostSelect = (event: any) => {
    setEventCost(event.detail.checked);
    let query: QueryFilters = new QueryFilters(location.search, facets);
    let newQuery: Filter = { ...query.parsedQuery };
    event.detail.checked
      ? (newQuery.eventCost = "free")
      : delete newQuery.eventCost;
    navigate(query, newQuery);
  };

  const onEventModeSelect = (event: any) => {
    setEventMode(event.detail.checked);
    let query: QueryFilters = new QueryFilters(location.search, facets);
    let newQuery: Filter = { ...query.parsedQuery };
    event.detail.checked ? (newQuery.online = true) : delete newQuery.online;
    navigate(query, newQuery);
  };


  const onSearch = (event: any) => {
    let query: QueryFilters = new QueryFilters(location.search, facets);
    let newQuery: Filter = { ...query.parsedQuery };
    event.detail ? (newQuery.search = event.detail) : delete newQuery.search;
    navigate(query, newQuery);
  };

  const resetSearch = () => {
    setSearchTerm("");
    let query: QueryFilters = new QueryFilters(location.search, facets);
    let newQuery: Filter = { ...query.parsedQuery };
    delete newQuery.search;
    navigate(query, newQuery);
  };

  const navigate = (query: QueryFilters, newQuery: Filter) => {
    //!location.pathname.includes('past') ? (newQuery.eventStatus = 'true') : delete newQuery.eventStatus;
    query.updateFiltersFromObject(newQuery);
    history.push(`${location?.pathname}?${query.filters}`);
  };

  const onDateSelect = (event: any) => {
    let startDate: number;
    let endDate: number;

    if (!!event?.detail) {
      startDate = moment(event.detail.startDate, "DD/MM/YYYY")
        .set({ hours: 0, minutes: 0, seconds: 0 })
        .unix();
      endDate = moment(event.detail.endDate, "DD/MM/YYYY")
        .set({ hours: 23, minutes: 59, seconds: 59 })
        .unix();
      setDateFilterType({
        type: "calendar",
        startDate,
        endDate,
      });
    } else {
      const today = moment().set({ hours: 0, minutes: 0, seconds: 0 }).unix();
      if (event === "week") {
        startDate = moment()
          .startOf("week")
          .set({ hours: 0, minutes: 0, seconds: 0 })
          .unix();
        endDate = moment()
          .endOf("week")
          .set({ hours: 23, minutes: 59, seconds: 59 })
          .unix();
        setDateFilterType({
          type: "week",
          startDate,
          endDate,
        });
      } else {
        startDate = moment()
          .startOf("month")
          .set({ hours: 0, minutes: 0, seconds: 0 })
          .unix();

        endDate = moment()
          .endOf("month")
          .set({ hours: 23, minutes: 59, seconds: 59 })
          .unix();
        setDateFilterType({
          type: "month",
          startDate,
          endDate,
        });
      }

      eventOn === "past" ? (endDate = today) : (startDate = today);
    }

    let query: QueryFilters = new QueryFilters(location.search, facets);
    let newQuery: Filter = { ...query.parsedQuery, startDate, endDate };
    navigate(query, newQuery);
  };

  const formatDate = (timeStamp: number): string => {
    return moment(timeStamp * 1000).format("DD/MM/YYYY");
  };
  // if (eventTypes.length > 0) this is commented for showing filters with no results!!!
    return (
      <>
        <DateBar
          mode={eventOn}
          onDateBarChange={(event: any) => {
            setDateFilterType(event);
          }}
        />
        <MarginBottom size={60} />
        <FILTER.FilterView>
          <FILTER.DateFilters>
            <FILTER.Reset
              direction={dir}
              label={constant[lang].VARIABLES.RESET}
              onBiuOnClick={onReset}
            />
            {dateFilterType.startDate && dateFilterType.endDate && (
              <FILTER.SelectedDateView direction={dir}>
                {formatDate(dateFilterType.startDate)}
                {" - "}
                {formatDate(dateFilterType.endDate)}
              </FILTER.SelectedDateView>
            )}
            <FILTER.DatePickers>
              <FILTER.Calendar
                mode={eventOn}
                isActive={dateFilterType.type === "calendar"}
                onBiuOnDateSelection={onDateSelect}
                language={dir}
                label={constant[lang].VARIABLES.CALENDAR_LABEL}
                dayHeaders={constant[lang].VARIABLES.CALENDAR_DAY_HEADERS}
                monthHeaders={constant[lang].VARIABLES.CALENDAR_MONTHS}
                rangeStartDate={
                  dateFilterType.type === "calendar"
                    ? dateFilterType.startDate
                    : null
                }
                rangeEndDate={
                  dateFilterType.type === "calendar"
                    ? dateFilterType.endDate
                    : null
                }
              />
              <FILTER.A
                order={2}
                onBiuOnClick={() => onDateSelect("month")}
                isActive={dateFilterType.type === "month"}
                label={constant[lang].VARIABLES.THIS_MONTH}
              />
              <FILTER.A
                order={1}
                onBiuOnClick={() => onDateSelect("week")}
                isActive={dateFilterType.type === "week"}
                label={constant[lang].VARIABLES.THIS_WEEK}
              />
            </FILTER.DatePickers>
          </FILTER.DateFilters>
          <FILTER.ParamFilters container spacing={5}>
            <Grid
              container
              item
              xl={3}
              lg={3}
              md={2}
              sm={6}
              xs={12}
              direction="row-reverse"
              spacing={3}
            >
              <FILTER.SearchBar
                onBiuOnReset={resetSearch}
                defaultValue={searchTerm}
                placeholder={constant[lang].VARIABLES.SEARCH}
                onBiuOnChange={onSearch}
              />
            </Grid>
            <Grid
              container
              item
              xl={3}
              lg={3}
              md={4}
              sm={6}
              xs={12}
              direction="row-reverse"
              spacing={3}
            >
              <BiuCheckbox
                label={constant[lang].VARIABLES.FILTER_FREE}
                checked={eventCost}
                onBiuOnCheck={onEventCostSelect}
              />
              <MarginRight size={8} />
              <BiuCheckbox
                label={constant[lang].VARIABLES.AN_ONLINE_EVENT}
                checked={eventMode}
                onBiuOnCheck={onEventModeSelect}
              />
            </Grid>
            <Grid
              container
              item
              md={3}
              sm={6}
              xs={12}
              direction="row-reverse"
              spacing={3}
            >
              <FILTER.Select
                options={JSON.stringify([
                  constant[lang].VARIABLES.DEFAULT_INTERESTED_DOMAIN,
                  ...interestedDomains,
                ])}
                onBiuOnOptionSelect={onInterestDomainSelect}
                defaultValue={interestDomain}
              />
            </Grid>

            <Grid
              container
              item
              md={3}
              sm={6}
              xs={12}
              direction="row-reverse"
              spacing={3}
            >
              <FILTER.Select
                options={JSON.stringify([
                  constant[lang].VARIABLES.DEFAULT_EVENT_TYPE,
                  ...eventTypes,
                ])}
                onBiuOnOptionSelect={onTypeSelect}
                defaultValue={eventType}
              />
            </Grid>

          </FILTER.ParamFilters>
        </FILTER.FilterView>
      </>
    );
};

export default Filters;
